// BaseControlView.js

import $                from 'jquery';
import Immutable        from 'immutable';
import {View}           from 'backbone';
import {Model}          from 'backbone';
import formModel        from 'formModel';
import dragAndDropService from 'DragDropService';
import listService      from 'ListService';
import geometryService  from 'GeometryService';
import undoService  from 'UndoService';
import userService              from 'UserService';
import constants        from 'Constants';
import textConstants    from 'TextConstants';
import util             from 'util/Util';
import imageUtil        from 'util/ImageUtil.js';
import resizeController from 'ResizeController';
import themeService     from 'ThemeService';
import BadgesFactory    from 'BadgesFactory';
import focusController  from 'FocusController';
import inlineEditor     from 'inline-text-input.html';
import inlineEditor2    from 'inline-text-area.html';
import numericUtil      from 'shared/NumericUtil';
import dateUtil         from 'shared/DateUtil';

import mobileListService from '../service/mobile/MobileListService';

import mobileAfterRender from '../views/mobile/MobileControlAfterRender';

import fontService from 'FontService';
import textUtil from 'util/TextUtil';


//=================================================================================
// Base class for Backbone views of controls on the page. Ultimately, each control
// is to be driven by Perfect Forms properties, stored as Backbone model
// attributes. A view's template file will refer to many of those attributes.
//
// Lou Mauget, December 12, 2015
//
//=================================================================================
class BaseControlView extends View {
    badgesView;

    initialize(options) {

        // The layout page. This id is Used to query its bounds.
        this.canvasId = constants.PAGESEL_ID;

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.options = options || {};
        this.groupItemsShown = false;

        // Note extending views that want these events should incoroporate: 'dblclick div.pf-editable' : 'handleDblClick'
        this.events = {
            'dblclick div.pf-editable' : 'handleDblClick'
        };

        this.model.set('id', this.id, constants.MODEL_SILENT); 
        
        this.$el = $(constants.FORM_ID);

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    // PF-2036 Edit text inline. Callback used by inline-editable controls. Invokes edit upon seeing a double-click.
    _editTextInline( ev, firstTime ) {

        // 1. Create a type=text input field matching the dimensions of the target text
        const
            tgt = ev.currentTarget,
            id = tgt.id,
            loc = {x: tgt.offsetLeft, y: tgt.offsetTop};

        console.log( id );

        // 1. Close $ed if one is already open (e.g. if double-clicked another control while editor open)
        if (listService.$ed) {
            listService.$ed.trigger('change');
            setTimeout( () => {
                listService.$ed.off('dblclick');
                listService.$ed.remove();
                listService.$ed = undefined;
            }, 0);
        }

        // focusController.toggleOneSelection( listService.currentId );
        // window.setTimeout(() => $('#' + id).removeClass('pfSelected'), 0);

        // Reliably get correct model for id
        // multi-line conditionally uses textarea as editor instead of text
        const
            model = listService.objectList.get( id ).model,
            $ed = $( model.get('factoryKey') === 'control_multiple_text_input' ? inlineEditor2 : inlineEditor);

        listService.$ed = $ed;

        const $core = $(constants.ID_SEL + id).find('div.pf-control-core');

        $ed.css({'font-family': $core.css('font-family'),
                'font-size': $core.css('font-size'),
                'font-style': $core.css('font-style'),
                'font-weight': $core.css('font-weight'),
                'left': tgt.clientX,
                'top': tgt.clientY,
                'border-radius': 0,
                'min-width': 100,
                'width': tgt.offsetWidth,
                'height': tgt.offsetHeight})
            .val(model.get('text'));

        // 3. Place the sized type=text temporarily atop the clicked ID field (preserve original)
        $(constants.ID_SEL + tgt.id).append($ed);

        // 4 Focus, and then select all
        window.setTimeout( () => {
            $ed.trigger('select');
        }, 10);

        // 5. Handle input, until enter or mouseout fires change
        $ed.off('change', "**");
        $ed.on('change', e => {
            $ed.off('change', '**');
            window.setTimeout(() => {
                textUtil.adjustTextWidth(model, $ed.val());
                model.set('text', $ed.val() );
                
                if(firstTime){
                    const name = util.createIdForControlName($ed.val(), model.get("factoryKey"));
                    $(".control-name").val(name).trigger("change");

                    if(ev.isLabel){
                        const inputModel = listService.objectList.get( ev.control ).model
                        const inputName = util.createIdForControlName($ed.val(), inputModel.get("factoryKey"));

                        window.setTimeout(() => {
                            focusController.clearAllSelected();
                            listService.currentId = ev.control;
                            listService.addToSelected(ev.control);
                            focusController.selectionRectangle(ev.control);
                            focusController.switchPropsViews();
                            $(".control-name").val(inputName).trigger("change");
                        }, 10);

                    }
                }
                window.setTimeout( () => {
                    $ed.remove();
                    if (listService.$ed) {
                        listService.$ed.off('dblclick', '**');
                        listService.$ed.remove(); // Doesn't hurt if already remmoved
                        listService.$ed = undefined;
                    }
                }, 0);
            }, 0);
        });

    }

    handleDblClick(evt) {
        if(listService.mainKind !== constants.KIND_MOBILE){
            evt.stopImmediatePropagation();
            this._editTextInline( evt );
        }
    }


    get subviews() {
        return this._subviews;
    }

    get pageId() {
        return this._pageId;
    }

    set pageId(pageId) {
        this._pageId = pageId;
    }

    get groupId() {
        return this._groupId;
    }

    set groupId(groupId) {
        this._groupId = groupId;
    }


    // Increasing z-index generator
    static get highZIndex() {
        if (!BaseControlView._highZIndex) {
            BaseControlView._highZIndex = 9;
        }
        return BaseControlView._highZIndex++;
    }


    // Neighbor aligner uses this polymorphic property (future)
    get kind() {
        return 'BaseControlView';
    }

    // Return object containing top and left
    get formPosition() {
        return $(constants.PAGESEL_ID);
    }


    //===============================================
    // Obliterate MOST traces of this view
    // (Could be on clipboard, but its
    // subviews are removed);
    // TODO: find and delete from clipboard?
    //==============================================
    remove() {
        this.unrender();

        this.$el.empty();
        this.undelegateEvents();
        this.stopListening();
        this.off();

        if(this.model){
            this.model.stopListening();
            this.model.unbind();
            //this.model = null;
        }

        super.remove();
    }

    //===============================================
    // Stop rendering view. Remove from system, but
    // don't destroy it, in case it's on the
    // clipboard temporarily.
    //==============================================
    unrender() {
        if(!this.model){
            return;
        }

        console.log("unrender", this.model.get('factoryKey'), this.$el);
        this.undelegateEvents();
        this.stopListening();
        this.off();

        if(this.badgesView){
            this.badgesView.remove();
        }

        if($('#' + this.model.get('id')).is('.ui-resizable')){
            $('#' + this.model.get('id')).resizable("destroy").unbind();
        }

        dragAndDropService.unlistenForDrop(constants.ID_SEL + this.id);
        resizeController.unlistenForResizeRequest();

        $(constants.ID_SEL + this.id).remove();
        $(constants.ID_SEL + this.id).empty();

        return this;
    }


    //==========================================================================================
    // Property true iff elemRect entirely contained within current PF page rectangle
    //==========================================================================================
    isEntirelyContained(pageRect, elemRect) {
        return geometryService.rect1ContainsRect2(pageRect, elemRect);
    } 


    //==========================================================================================
    // Property: Perfect Forms current page width and height.
    //
    // Resembles property in DragDropService
    //==========================================================================================
    get pageDim() {
        return {
            width: util.extractNum($(this.canvasId).width()) + 2,
            height: util.extractNum($(this.canvasId).height()) + 2
        };
    }


    //==========================================================================================
    // Property: Perfect Forms current page rectangle in offset coordinates compensated for
    // window scroll position.
    //
    // Simpler version of property in DragDropService
    //==========================================================================================
    get pageRect() {
        return {
            top: -1,
            left: -1,
            height: this.pageDim.height,
            width: this.pageDim.width
        };
    }  


    //=======================================================================
    // Returns this control's page rectangle as defined by current model.
    //=======================================================================
    getElemRect(model) {
        return {
            left: Number(model.get('left')),
            top: Number(model.get('top')),
            width: util.extractNum(model.get('width')),
            height: util.extractNum(model.get('height'))
        };
    }

    // =========================================================================================================
    // Method that renders the validation in the UI for a control that is not inside the working area.
    // Works in conjunction with the PageSyncService that should have been placed the layout type value before.
    // =========================================================================================================
    setValidControl(isValid) {
        if (isValid) {
            this.model.set('invalid', false, constants.MODEL_SILENT);
        }
        else {
            $(constants.ID_SEL + this.id + ' .pf-selectable').addClass('outOfBounds');
            this.model.set('invalid', true, constants.MODEL_SILENT);
        }
    }


    //=======================================================================
    // Descendant is a control. Confine it to the page. I.E. no pathological
    // model position user input should allow moving any part of the the
    // control beyond a page border.
    //=======================================================================s
    validateToStayInBounds(model, isControlCreation = false) {
        let isGoodMove = false;
        if (isControlCreation) {
            isGoodMove = geometryService.isValidOverlapping(this.pageRect, this.getElemRect(this.model)); 
        }
        else {
            isGoodMove = this.isEntirelyContained(this.pageRect, this.getElemRect(this.model)); 
        }

        if (!isGoodMove) {
            if ( (formModel.get('currentDevice') === 'deviceTablet' || formModel.get('currentDevice') === 'devicePhone')
                && !this.model.get('isHidden') ) {
                this.setValidControl(false);
            }
            else {
                //you should be able to enter data even if it goes off screen
                //it will not be visible though because it will be behind right rail
                //model.set(model.previousAttributes());
            }
        }
        else {
            this.setValidControl(true);
        }
    } 


    //====================================================================================
    // Global check for hiding a control so it cannot be placed in all of the templates.
    //====================================================================================
    _hideControl(elemId, isHidden) {
        if (isHidden) {
            $(elemId).addClass(constants.CLASS_HIDDEN);
        }
        else {
            $(elemId).removeClass(constants.CLASS_HIDDEN);
        }
    }

    resolveThemeProp(val) {
        return themeService.resolve(val);
    }

    getValueFromTheme(base, prop) {
        var propArray = this.normalizedThemeArray(base);
        switch (prop) {
            case 'fontFamily': 
                return propArray[0].trim();
            case 'fontSize':
                return propArray[1].trim();
            case 'textWeight':
                return propArray[2].trim();
            case 'textStyle':
                return propArray[3].trim();
            default:
                break;
        }
        // So we never hit the default? This returns undefined if so.
    }

    normalizedThemeArray(base) {
        const propArray = themeService.resolve(base).split(',');
        const result = [];
        if (propArray[0]) {
            result[0] = propArray[0].trim();
        } else {
            result[0] = 'arial';
        }
        if (propArray[1]) {
            result[1] = propArray[1].trim();
        } else {
            result[1] = '10';
        }
        if ((propArray[2] && propArray[2].toLowerCase().indexOf('bold') > -1)
            || (propArray[3] && propArray[3].toLowerCase().indexOf('bold') > -1)) {
            result[2] = 'bold'
        } else {
            result[2] = 'normal';
        }
        if ((propArray[2] && propArray[2].toLowerCase().indexOf('italic') > -1)
            || (propArray[3] && propArray[3].toLowerCase().indexOf('italic') > -1)) {
            result[3] = 'italic'
        } else {
            result[3] = 'normal';
        }
        return result;
    }

    isThemeProperty(val) {
        // let result = false;
        // if (val && typeof val === 'string' && val.length > 0 && val.charAt(0) === '~') {
        //     result = true;
        // }
        // return result;
        return val && typeof val === 'string' && val.length > 0 && val.charAt(0) === '~';
    }

    setFontThemeValues(that, themeProperty) {
        // normalize the theme property
        const fontProp = themeService.resolve(themeProperty).split(',');

        fontProp[0] = fontProp[0].trim();
        fontProp[1] = fontProp[1].trim();

        let textWeight = '';
        if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('bold') > -1) ||
            (fontProp[3] && fontProp[3].toLowerCase().indexOf('bold') > -1)) {
            textWeight = 'bold';
        } else {
            textWeight = 'normal';
        }

        let textStyle = '';
        if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('italic') > -1) ||
            (fontProp[3] && fontProp[3].toLowerCase().indexOf('italic') > -1)) {
            textStyle = 'italic';
        } else {
            textStyle = 'normal';
        }
        fontProp[2] = textWeight;
        fontProp[3] = textStyle;

        themeService._theme[themeProperty] = fontProp.join(',');
        // set values to theme property
        that.model.set('fontFamily', themeProperty, constants.MODEL_SILENT);
        that.model.set('fontSize', themeProperty, constants.MODEL_SILENT);
        that.model.set('textWeight', themeProperty, constants.MODEL_SILENT);
        that.model.set('textStyle', themeProperty, constants.MODEL_SILENT);
    }

    resolveThemeFont(prop, val) {
        return this.isThemeProperty(val) ? this.getValueFromTheme(val, prop) : val;
    }

    resolveThemeBorder(prop, val) {
        return this.isThemeProperty(val) ? this.getBorderValueFromTheme(val, prop) : val;
    } 

    resolveFontProps(props) {
        props.styleColorText = this.resolveThemeProp(props.styleColorText);
        props.fontFamily = this.resolveThemeFont('fontFamily', props.fontFamily);
        props.fontSize = this.resolveThemeFont('fontSize', props.fontSize);
        props.textWeight = this.resolveThemeFont('textWeight', props.textWeight);
        props.textStyle = this.resolveThemeFont('textStyle', props.textStyle);
    
        if (props.buttonFontFamily) {
            props.buttonFontFamily = this.isThemeProperty(props.buttonFontFamily) ? this.getValueFromTheme(props.buttonFontFamily, 'fontFamily') : props.buttonFontFamily;
            //props.buttonFontFamily = this.isThemeProperty(props.buttonFontFamily) ? themeService.resolve(props.buttonFontFamily) : props.buttonFontFamily;
            //this.isThemeProperty(props.buttonFontFamily) ? this.theme[ props.buttonFontFamily ] : props.buttonFontFamily; //this.resolveThemeProp(props.buttonFontFamily);
        }
        if (props.buttonFontSize) {
            props.buttonFontSize =this.isThemeProperty(props.buttonFontSize) ? this.getValueFromTheme(props.buttonFontSize, 'fontSize') : props.buttonFontSize;
        }
        if (props.buttonTextStyle) {
            props.buttonTextStyle =this.isThemeProperty(props.buttonTextStyle) ? this.getValueFromTheme(props.buttonTextStyle, 'textStyle') : props.buttonTextStyle;
        }
        if (props.buttonTextWeight) {
            props.buttonTextWeight =  this.isThemeProperty(props.buttonTextWeight) ? this.getValueFromTheme(props.buttonTextWeight, 'textWeight') : props.buttonTextWeight;
        }

        let titleFont = '';
        if (props.titleFont){
            titleFont = this.getValueFromTheme(props.titleFont, 'fontFamily');
        }

        const webFont = fontService.webFonts.find(font => font.name === props.fontFamily || font.name === props.buttonFontFamily || font.name === titleFont);

        if (webFont) {
            fontService.loadWebFontResource(webFont);
        }
    }

    resolveTitleFontProps(props) {
        props.titleText = this.resolveThemeProp(props.titleText);
        props.titleFontFamily = this.resolveThemeFont('fontFamily', props.titleFontFamily);
        props.titleFontSize = this.resolveThemeFont('fontSize', props.titleFontSize);
        props.titleTextWeight = this.resolveThemeFont('textWeight', props.titleTextWeight);
        props.titleTextStyle = this.resolveThemeFont('textStyle', props.titleTextStyle);
    }

    resolveBorderProps(props) {
        props.borderColor = this.resolveThemeProp(props.borderColor);
        props.borderSize = this.resolveThemeBorder('borderSize', props.borderSize);
        props.borderStyle = this.resolveThemeBorder('borderStyle', props.borderStyle);
        props.cornerRadius = this.resolveThemeBorder('cornerRadius', props.cornerRadius);
    }

    resolveRankingProps(props) {
        props.overflow = 'overflow: hidden';
        if (props.height < 90) {
            props.overflow = 'overflow-y: scroll';
        }
    }

    getBorderValueFromTheme(base, prop) {
        const propArray = themeService.resolve(base).split(',');
        if (propArray.length > 1) {
            switch (prop) {
                case 'borderSize':
                    return propArray[0].trim();
                case 'borderStyle':
                    return propArray[1].trim();
                case 'cornerRadius':
                    return propArray[2]? propArray[2].trim() : '0';
                default:
                    break;
            }
        } else {
            return themeService.resolve(base)
        }
        // TODO: it returns undefined  here if nothing hits above - Lou Mauget 26-April-16

    }

    resolveAdvancedBackgroundTheme(props) {
        if (props.backgroundColor) {
            props.backgroundColor = this.resolveThemeProp(props.backgroundColor);

        }
        if (props.advancedBgGradientColor) {
            props.advancedBgGradientColor = this.resolveThemeProp(props.advancedBgGradientColor);

        }
    }

    resolveButtonBackground(props) {
        if (props.buttonBackgroundColor) {
            props.buttonBackgroundColor = this.resolveThemeProp(props.buttonBackgroundColor);

        }
        if (props.buttonBackgroundGradientColor) {
            props.buttonBackgroundGradientColor = this.resolveThemeProp(props.buttonBackgroundGradientColor);

        }
    }
    resolveButtonFontPro(props) {
        if (props.buttonTextColor) {
            props.buttonTextColor = this.resolveThemeProp(props.buttonTextColor);

        }
    }

    resolveCheckboxBackgroundProps(props) {
        props.backgroundColor = this.resolveThemeProp(props.backgroundColor);
        props.styleBGColorText = this.resolveThemeProp(props.styleBGColorText);
        props.transparentBackground = this.isThemeProperty(props.transparentBackground) ? themeService.resolve(props.transparentBackground) : props.transparentBackground;
        
    }

    resolveBackgroundProps(props) {
        props.backgroundColor = this.resolveThemeProp(props.backgroundColor);
        props.styleBGColorText = this.resolveThemeProp(props.styleBGColorText);
    }

    applyButtonStyle(props) {
        if (props.buttonStyle) {
            // Resolve style source:
            const value = this.isThemeProperty(props.buttonStyle) ? themeService.resolve(props.buttonStyle) : props.buttonStyle;

            // Adjust style for rounded vs rectangular:
            if (value==='roundMouseOver') {
                props.cornerRadius = 2;
                props.borderStyle = 'none';
                props.backgroundColor = 'transparent';
                props.advancedBgGradientColor = 'transparent';
            }
            else if (value==='rectMouseOver') {
                props.cornerRadius = 0;
                props.borderStyle = 'none';
                props.backgroundColor = 'transparent';
                props.advancedBgGradientColor = 'transparent';
            }
        }
    }

    //===========================================================================================================
    // if a well-knonw prop key is of-interest and its value is of form 'xxxxxx' then it must be a color value
    // missing a leading '#'. If so, prefix the '#' to the property's value in the model.
    //===========================================================================================================
    fixupColorExprs() {
        // Add props / model attribute names here that take CSS color values (or rgb or rgba or color name).
        const colorPropNames = Immutable.Map({
            backgroundColor: 1,
            borderColor: 1,
            pageColor: 1,
            shadowColor: 1,
            styleColorText: 1
        });

        // if entire value string for colorPropNames is of form 'xxxxxx' then it must be a color value missing a leading '#'
        Immutable.Map(this.model.attributes)
            .filter((v, k) => colorPropNames.has(k) && util.isCssHexColor(v))
            .map((v, k) => this.model.set(k, `#${v}`));
    }

    setBgColorThemeValues() {
        let bgColor = this.model.get('backgroundColor');
        if (this.isThemeProperty(bgColor)) {
            // modify the value in order to trigger the render
            this.model.set('backgroundColor', themeService.resolve(bgColor));
            // keep the themeg value
            this.model.set('backgroundColor', bgColor, constants.MODEL_SILENT);
        }
    }


    resolveForGroups(props) {
        this.resolveTitleFontProps(props);
        this.resolveBorderProps(props);
        props.titleBackgroundColor = this.resolveThemeProp(props.titleBackgroundColor);
        props.backgroundColor = this.isThemeProperty(props.backgroundColor) ? themeService.resolve(props.backgroundColor) : props.backgroundColor;
        props.transparentBackground = this.isThemeProperty(props.transparentBackground) ? themeService.resolve(props.transparentBackground) : props.transparentBackground;
        props.bgImage = this.isThemeProperty(props.bgImage) ? themeService.resolve(props.bgImage) : props.bgImage;
        props.titleColor = this.isThemeProperty(props.titleColor) ? themeService.resolve(props.titleColor) : props.titleColor;
    }

    resolveForSeparators(props) {
        props.lineColor = this.resolveThemeProp(props.lineColor);
        props.width = this.resolveThemeProp(props.width);
        props.height = this.resolveThemeProp(props.height);
    }

    resolveCaptchaProps(props) {
        props.backgroundColor = this.resolveThemeProp(props.backgroundColor);
        props.styleColorText = this.resolveThemeProp(props.styleColorText);
        props.width = this.resolveThemeProp(props.width);
        props.height = this.resolveThemeProp(props.height);
        props.length = this.resolveThemeProp(props.length);
    }

    resolveSectionHeaderProps(props) {
        props.headerBackgroundColor = this.resolveThemeProp(props.headerBackgroundColor);
        props.headerColor = this.resolveThemeProp(props.headerColor);
        props.headerFontFamily = this.resolveThemeProp(props.headerFontFamily);
        props.headerFontSize = this.resolveThemeProp(props.headerFontSize);
        props.headerTextWeight = this.resolveThemeProp(props.headerTextWeight);
        props.headerFontFamily = this.resolveThemeFont('fontFamily', props.headerFontFamily);
        props.headerFontSize = this.resolveThemeFont('fontSize', props.headerFontSize);
        props.headerTextWeight = this.resolveThemeFont('textWeight', props.headerTextWeight);
        props.headerTextStyle = this.resolveThemeFont('textStyle', props.headerTextStyle);
        props.headerBorderStyle = this.resolveThemeProp(props.headerBorderStyle);
        props.headerBorderSize = this.resolveThemeProp(props.headerBorderSize);
        props.headerBorderColor = this.resolveThemeProp(props.headerBorderColor);
    }

    resolveSectionProps(props) {
        props.backgroundColor = this.resolveThemeProp(props.backgroundColor);
        props.backgroundImage = this.resolveThemeProp(props.backgroundImage);
        props.backgroundImageAssetId = this.resolveThemeProp(props.backgroundImageAssetId);
        props.transparentBackground = this.resolveThemeProp(props.transparentBackground);
        props.borderStyle = this.resolveThemeProp(props.borderStyle);
        props.borderSize = this.resolveThemeProp(props.borderSize);
        props.borderColor = this.resolveThemeProp(props.borderColor);
        props.cornerRadius = this.resolveThemeProp(props.cornerRadius);
    }

    resolvePropsForControl(props) {
        switch (props.factoryKey) {
            case 'control_group':
            case 'control_checkbox_group':
            case 'control_radio_button_group':
                this.resolveForGroups(props);
                break;
            case 'control_vertical_slider':
            case 'control_vertical_separator':
            case 'control_horizontal_slider':
            case 'control_horizontal_separator':
                this.resolveForSeparators(props);               
                this.resolveFontProps(props);
                break;
            case 'control_ranking':
                this.resolveFontProps(props);
                this.resolveBorderProps(props);
                this.resolveBackgroundProps(props);
                this.resolveRankingProps(props);
                break;
            case 'control_date_input':
            case 'control_drop_down':
            case 'control_mask_text_input':
            case 'control_numeric_input':
            case 'control_password_input':
            case 'control_date_calendar':
            case 'control_text_input':
            case 'control_multiple_text_input':
            case 'control_time_input':
            case 'control_list':
            case 'control_numeric_stepper':
            case 'control_filter_selector':
            case 'control_filter_input':
                this.resolveFontProps(props);
                this.resolveBorderProps(props);
                this.resolveBackgroundProps(props);
                break;
            case 'control_file_attachment':
            case 'control_websignature':
            case 'control_image_input':
                this.resolveFontProps(props);
                this.resolveBorderProps(props);
                this.resolveAdvancedBackgroundTheme(props);
                this.resolveButtonBackground(props);
                this.resolveButtonFontPro(props);
                break;
            case 'control_checkbox':
            case 'control_radio_button':
                this.resolveFontProps(props);
                this.resolveBorderProps(props);
                this.resolveCheckboxBackgroundProps(props);
                this.resolveAdvancedBackgroundTheme(props);
                break;
            case 'control_text':
            case 'control_bullet_text':
            case 'control_small_text':
            case 'control_large_heading':
            case 'control_medium_heading':
            case 'control_small_heading':
            case 'control_link':
                this.resolveFontProps(props);
                break;
            case 'control_button':
            case 'control_submit_button':
            case 'control_page_button':
            case 'control_print_button':
            case 'control_play_form_button':
            case 'control_play_report_button':
            case 'control_clear_filter_button':
                this.resolveFontProps(props);
                this.resolveBorderProps(props);
                this.resolveAdvancedBackgroundTheme(props);
                this.applyButtonStyle(props);
                break;
            case 'control_captcha':
                this.resolveCaptchaProps(props);
                break;
            case 'control_section':
                this.resolveForGroups(props);
                this.resolveSectionProps(props);
                this.resolveTitleFontProps(props);
                this.resolveSectionHeaderProps(props);


                break;
            default:
                break;
        }
    }

    themeChangeRender() {
        if (this._pageId === listService.currentPageId) {
            this.render();
        }
    }

    mobileMarginChangeRender(value, isFont){        
        if (this.model.get("container") && value){
            if(!isFont){
                this.model.set('~margins', value.split("-"), constants.MODEL_SILENT);
                listService.updateMarginDefaultByKey("control_margin", value.toString()); 
            }else{
                this.model.set("marginSize", value, constants.MODEL_SILENT);    
                listService.updateMarginSizeByKey("control_margin", value.toString());              
            }
            listService.setDirty(true);
            util.enableSaveOption();
            this.render("marginChange");
        }
    }

    close (){
        this.unbind();
        if (this.onClose){
            this.onClose();
        }
        this.remove();
    }

    enableListeners() {
        if (listService.mainKind !== constants.KIND_MOBILE && !listService.isMobileOpen) {
            // Enables control resizing through directly dragging its border
            resizeController.listenForResizeRequest(this.id);
            dragAndDropService.listenForDrop(constants.ID_SEL + this.id);
        }
    }

    showBages(){
        this.badgesView = BadgesFactory.createBadgesView(this.model);

        if(this.badgesView){
            this.badgesView.render();
            $(constants.ID_SEL + this.id).append(this.badgesView.$el);
        }
    }

    hideBages(){
        if($(constants.ID_SEL + this.id).find('.pf-badge').is(':visible')){
           $(constants.ID_SEL + this.id).find('.pf-badge').remove();
        }
    }

    //=======================================================================
    // Paints control at position defined by current model position values.
    //=======================================================================
    render(renderOptions) {
       
        console.log("render", this.model.get('factoryKey'));

        if(!listService.isMobileOpen && listService.mainKind !== constants.KIND_MOBILE){
            if (listService.currentPageId !== this._pageId || this.model.get('id') !== this.id) {
                return;
            }
        }
        let pageSel = constants.PAGE_ID;
        let nodeIndex = -1;

        if (listService.isMobileOpen) {
            pageSel = constants.PAGE_ID_HIDEN;
        } 
        else if(listService.mainKind === constants.KIND_MOBILE){
                pageSel = `#${renderOptions && renderOptions.container ? renderOptions.container : this.model.get("container")}`;
                
                if((this.model.get('factoryKey') === "control_checkbox" || this.model.get('factoryKey') === "control_radio_button") && this.groupId){
                    pageSel = `#${this.model.get("groupContainer") ? this.model.get("groupContainer") : pageSel}`;
                }       
                
                nodeIndex = $(constants.ID_SEL + this.id).index();                       
            }



        // preprocessing some controls, but on the same  render functions, to avoid performance issues
        switch (this.model.get('factoryKey')) {
            case 'control_numeric_input':
                numericUtil.transform(this.model);
                break;
            case 'control_date_input':
                dateUtil.updateValueType(this.model);
                dateUtil.updateModel(this.model);
                break;
            case 'control_group':
            case 'control_radio_button_group':
            case 'control_checkbox_group':
            case 'control_section':
                this.adjustPictureSettings();
                break;
            case 'control_picture':
                this.adjustPictureSettings();
                break;
            case 'control_table':
                util.saveGridScrollPos(this.model, '#gview_gridColumns > div.ui-jqgrid-bdiv');
                break;
            case 'control_mask_text_input':
                this.reprintMask();
                break;
         
        }

        // render actions
        const self = this;
        $(constants.ID_SEL + this.id).remove();

        let props = this.model.toJSON();
        this.resolvePropsForControl(props);
       

        // PF-8700 Added transparency for radio buttons and checkboxes
        if (constants.GROUP_KEYS.includes(this.model.get('factoryKey')) || this.model.get('factoryKey') === 'control_section'
            || constants.TRANSPARENT_CONTROL_KEYS.includes(this.model.get('factoryKey'))) {
            // Group Background ********************************
            // insert RGBAColor property
            let rgb = util.hexToRgb(props.backgroundColor);
            let rgba = 'transparent';
            if (rgb) {
                let a = '1'; // just in case we need to change the opacity.
                rgba = 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + a + ')';

                if (util.isTrue(props.transparentBackground)) {
                    rgba = 'transparent';
                }
            }

            if (constants.GROUP_KEYS.includes(this.model.get('factoryKey')) || this.model.get('factoryKey') === 'control_section') {
                props.GroupBackgroundColor = rgba;
            } else {
                props.backgroundColor = rgba;
            }

            // *************************************************
        }

        // Note: Don't use this.$el. Desktop could have been closed and rebuilt while control held in listService.   
        // PF-2223: Shadow element when undo action is performed on sytle changes... (append of element has already been executed in other step of the undo/redo)
        if (!this.model.changed.hasOwnProperty('undoAction') || (this.model.changed.hasOwnProperty('undoAction') && !this.model.changed.undoAction) ) {
            if(this.model.get('factoryKey') === 'control_captcha'){
                // PF-3935 Turning on the flag so we dont get a different image on every move.
                props.captchaImage = imageUtil.getCaptchaPresentationServerURLByView(this);
                this.model.set('keepText', true, constants.MODEL_SILENT);
            }

            if (listService.mainKind === constants.KIND_MOBILE && (listService.isSelected(this.id) || renderOptions === "marginChange") && this.model.get('factoryKey') !== 'control_section') {
                let $target = $(pageSel).children().eq(nodeIndex);
                $target.length > 0 ? $target.before(this.template(props)) : $(pageSel).append(this.template(props));  
            }
            else {
                    if (this.model.get('factoryKey') === 'control_section') {

                        const insertAtIndex = (index) => {                         
                            const currentPosition =  $(pageSel + " > div:nth-child(" + (index) + ")");
                            if(index > 0 && currentPosition){

                                if(currentPosition.length){
                                    $(pageSel + " > div:nth-child(" + (index) + ")").after(this.template(props));
                                }
                                else{
                                    $(pageSel).append(this.template(props));
                                }
                            }
                            else{
                                $(pageSel).prepend(this.template(props)); 
                            }
                        }

                        insertAtIndex(this.model.get("index"));
                    }
                    else {
                        $(pageSel).append(this.template(props));
                    }
            }
        }

        //after rendering
        const isRadio = this.model.get('factoryKey') === 'control_radio_button';
        //we set same state when Rabio buttons is inside a group
        if (this.groupId && isRadio) {
                let groupObj = listService.getObject(this.groupId);
                this.model.set('state',groupObj.model.attributes.state,constants.MODEL_SILENT);
        }
        //we dont paint bages for alone Radio buttons
        if(!isRadio){
            if(userService.userSettings.get('_edShSM')){
                this.showBages();
            }
            else {
                this.hideBages();
            }
        }
        else{
            if (this.groupId){
                if(userService.userSettings.get('_edShSM')){
                    this.showBages();
                }
                else{
                    this.hideBages();
                }
            }
        }

        this._hideControl(constants.ID_SEL + this.id, this.model.get('isHidden'));

        this.validateToStayInBounds(this.model);

        this.delegateEvents();



        //Conditionally enable listeners, these are expensive. Do not need when rendering all controls on page or when moving selected group of controls.
        //By default we do not need to skip event registration, if it is not specified then we only evaluate if the count for selected controls is less than 2
        let skipRegistration = false;
        if ((renderOptions && renderOptions.skipEventRegistration) || listService.mainKind === 'M') {
            skipRegistration = true;
        }

        // Always enable listeners for groups
        if (!skipRegistration || constants.GROUP_KEYS.includes(this.model.get('factoryKey'))) {
            this.enableListeners();
        }

        if (this.model.get('factoryKey') !== 'control_mask_text_input' || (listService.mainKind === constants.KIND_MOBILE && !listService.isMobileOpen)) {
            $(constants.ID_SEL + this.id).append('<div class="ui-resizable-handle ui-resizable-nw" id="nwgrip"></div>')
            $(constants.ID_SEL + this.id).append('<div class="ui-resizable-handle ui-resizable-ne" id="negrip"></div>')
            $(constants.ID_SEL + this.id).append('<div class="ui-resizable-handle ui-resizable-sw" id="swgrip"></div>')
            $(constants.ID_SEL + this.id).append('<div class="ui-resizable-handle ui-resizable-se" id="segrip"></div>')
        }

        this.createResizeControl();

        if ((this.groupId && listService.mainKind !== constants.KIND_MOBILE) || (this.groupId && listService.isMobileOpen)) {
            $(constants.ID_SEL + this.id).appendTo(`${constants.ID_SEL}${'groupItems' + this.groupId}`);
        }

       if(this.model.get('factoryKey')=== 'control_table') {

           if (listService.isResizing && listService.layoutControlHTML && !this.tableGhostShown) {
               $('#' + this.model.id).html(listService.layoutControlHTML);
               this.tableGhostShown = true;
           }
           else {
               listService.layoutControlHTML = undefined;
               listService.isResizing = false;
               this.adjustAfterRender();
               this.tableGhostShown = false;
           }
        }
        else if (this.model.get('factoryKey') === 'control_section') {
            this.controlsRender();
        }else if (constants.GROUP_KEYS.includes(this.model.get('factoryKey'))) {




               listService.isResizing = false;
               this.afterRenderingGroups(renderOptions);

       }

        if (listService.isSelected(this.id)) {
            focusController.selectionRectangle(this.id, true)
        }

        //Clean controls for mobile
        if(listService.mainKind === constants.KIND_MOBILE && !listService.isMobileOpen){
            let mobileControl = mobileAfterRender.controlList().find(control => control.factoryKey === this.model.get('factoryKey'));
            if(mobileControl){
                mobileControl.control.afterRender(this);
            }
        }


        return this;
    }

    createResizeControl() {
        const self = this;

        // the resize value is used when redrawing the control during the resize event. the reason they are different is because not all templates are the same and no they can't be...
        const resizeValue = this.model.has('resizePadding') ? this.model.get('resizePadding') : 0;
        const resizeValueH = this.model.has('resizePaddingH') ? this.model.get('resizePaddingH') : resizeValue;
        const resizePadding = resizeValue;
        // Resize padding = 12 (Input)
        let minWidth;
        let minHeight;
        if (this.model.get('minWidth')) {
            minWidth = this.model.get('minWidth');
        } else {
            minWidth = constants.CONTROL_MIN_WIDTH;
        }
        if (this.model.get('minWidth')){
            minHeight = this.model.get('minHeight');
        }else{
            minHeight = constants.CONTROL_MIN_HEIGHT;
        }

        let handles =  {
            'ne': '#negrip',
            'se': '#segrip',
            'sw': '#swgrip',
            'nw': '#nwgrip'
        };
        

        let $parent = constants.PAGE_ID;
        if (self && self.groupId) {
            $parent = $('#' + self.groupId);
        }

        const control = $('#' + this.model.get('id'));
        if (control.is('.ui-resizable')) {
            control.resizable('destroy');
        }

        control.resizable({
            handles: handles,
            resize: function(event, ui ) {
                const height = (ui.size.height - resizeValueH) <= ui.size.height ? ui.size.height : ui.size.height - resizeValueH;
                const width = (ui.size.width - resizePadding) <= ui.size.width ? ui.size.width : ui.size.width - resizePadding;
                const $control = util.jqId( self.model.get('id') );
                const $firstChild = $control.find('div.pf-control-core > div:first');

                // PF-2524: Resize only the parent element, for groups
                if ( self.model.get('isGroupContainer') ) {
                    // PF-2524: Checking if a new element was added to the group from drag&drop
                    if (minWidth !== self.model.get('minWidth') || minHeight !== self.model.get('minHeight')) {
                        $('#' + self.model.get('id')).resizable("option","minWidth", self.model.get('minWidth'));
                        $('#' + self.model.get('id')).resizable("option","minHeight", self.model.get('minHeight'));
                    }
                    $control.find('div.pf-control-core').first().width(width).height(height);
                } else { // Resize handler for all other individual controls
                    $('#' + self.model.get('id') + ' .pf-selectable').width(width).height(height);
                }
                $('#' + self.model.get('id') + ' .pf-selectable').css('min-height', '');

                // PF-2524: Custom logic for live preview on resize of websignature control
                if ( self.model.get('factoryKey') === 'control_websignature' ) {
                    let newHeight = height - $control.find('div.pf-control-core > div:eq(1)').height();
                    $firstChild.width(width-4).height(newHeight);
                }

                // PF-2524: Custom logic for live preview on resize of table control
                if ( self.model.get('factoryKey') === 'control_table'){
                    let newHeight = height - $control.find('div.table-footer').height();
                    $control.find('div.table-footer').width(width);
                    $control.find('div.ui-jqgrid-bdiv').width(width).height(newHeight-21);
                    $control.find('div.ui-jqgrid-hdiv').width(width);
                    $firstChild.width(width).height(newHeight);
                }

                if (self.model.get('factoryKey') === 'control_crosstab'){
                    let $table=$control.find('table');
                    $table.width(width).height(height);
                }

                if (self.model.get('factoryKey') === 'control_data_grid' || self.model.get('factoryKey') === 'control_data_list'){
                    let $horizontalContainer=$control.find('div.horizontal');
                    let $table=$control.find('table');
                    let $mainContainer=$control.find('div.pf-control-core');

                    // PF-2843 Performing calculation for increase container,table and container with overflow.
                    $mainContainer.width(width).height(height);
                    $horizontalContainer.css('overflow','visible');
                    $horizontalContainer.width(width).height(height - 30);
                    $table.width(width).height(height - 30);

                    let gridData = self.model.get('gridData');

                    // Sum the column widths used for decision to extend final col vs insert the horiz scroll bar
                    const columnWidthSum = ( cModel => {
                        let sum = 0;
                        _.forEach( cModel, (v, k) => {
                            if(k === gridData.length -1){return false;}
                            sum += parseInt(v.width);
                        });
                        return sum;
                    })(gridData);


                    // Extend final column if and only if table width > sum of column widths

                    // PF-2843 Increasing last column only.
                    const dw = width - columnWidthSum;
                    $control.find('table th:last-child').width(dw);
                    $control.find('table td:last-child').width(dw);
                }

                if (self.model.get('factoryKey') === 'control_date_calendar'){
                    const idSelector = constants.ID_SEL + self.model.attributes.id;
                    $(`${idSelector} .ui-datepicker`).css('width',width).css('height',height);

                    const headerHeight = Number(self.model.get("fontSize")) * 2.5;
                    const paddingFactor = 1.5;

                    $(`${idSelector} .ui-datepicker td a`).css({'width': width / 10 - paddingFactor + 'pt',
                        'height': (height - headerHeight) / 10 - paddingFactor + 'pt'});
                }

                // PF-2524: Fix for live preview during resize event
                if ( self.model.get('factoryKey') === 'control_date_input' ) {
                    $firstChild.width(width).height(height-6);
                }

                // PF-2524: Fix for live preview during resize event
                if ( self.model.get('factoryKey') === 'control_time_input' ) {
                    $firstChild.width(width).height(height-2);
                }

                // PF-2524: Live preview resize for horizontal and vertical slider
                if ( self.model.get('factoryKey') === 'control_horizontal_slider' ) {
                    $control.find('div.h-slider').width(width-10);
                }

                if ( self.model.get('factoryKey') === 'control_vertical_slider' ) {
                    $control.find('div.v-slider').height(height-10);
                }

                if ( self.model.get('factoryKey') === 'control_ranking' ) {
                    let heightOfInnerContent = $control.height()-40;
                    $control.find('#controlRankingListDiv').height(heightOfInnerContent);
                    if ($control.height() < 90) {
                        $control.find('#controlRankingListDiv').css('overflow', '').css('overflow-y', 'scroll');
                    } else {
                        $control.find('#controlRankingListDiv').css('overflow', 'hidden').css('overflow-y', '');
                    }
                }

                // Centering text just for buttons.
                if (self.model.get('factoryKey').includes('button')) {

                    let controlComponent = $('#' + self.model.get('id') + ' .pf-selectable');
                    let controlPosition = controlComponent.position();
                    let controlX = controlPosition.left;
                    let controlY = controlPosition.top;
                    let labelPosition = $('#' + self.model.get('id') + ' .pf-selectable div.i').first();

                    // Performing calculation of text centering
                    $('#' + self.model.get('id') + ' .pf-selectable div.i').parent().css({position: 'relative'});
                    $('#' + self.model.get('id') + ' .pf-selectable div.i')
                        .first()
                        .css(
                            {
                                top: (controlY + (height / 2)) - (labelPosition.height() / 2),
                                left: (controlX + (width / 2)) - (labelPosition.width() / 2),
                                position: "absolute"
                            })
                }

                // Adjusting resizing preview on pictures.
                if (self.model.get('factoryKey') === ('control_picture')) {
                    let bStretch = util.isTrue(self.model.get('stretch'));
                    let bMaintainRatio = util.isTrue(self.model.get('maintainAspectRatio'));
                    let imageToAdjust=$('#' + self.model.get('id') + ' .pf-selectable img');

                    let styleTag = '';
                    if (bStretch && !bMaintainRatio) {
                        styleTag = `height: 100%; width: 100%; max-height: ${height}px ;max-width: ${width}px`;
                    }

                    else if(bStretch && bMaintainRatio) {

                        // Performing calculation based on real image size
                        let naturalWidth = !imageToAdjust.prop('naturalWidth') ? 1 : imageToAdjust.prop('naturalWidth');
                        let naturalHeight = !imageToAdjust.prop('naturalHeight') ? 1 : imageToAdjust.prop('naturalHeight');

                        let adjustedHeight = width * naturalHeight /  naturalWidth;
                        let adjustedWidth = height * naturalWidth / naturalHeight;

                        adjustedHeight = isNaN(adjustedHeight) ? height : adjustedHeight;
                        adjustedWidth = isNaN(adjustedWidth) ? width : adjustedWidth;

                        styleTag = `max-width: ${width}px;max-height: ${height}px;height:${adjustedHeight}px;width:${adjustedWidth}px`;

                    }
                    imageToAdjust.attr('style',styleTag);
                }
            },
            stop: function( event, ui ) {
                const x = ui.position.left;
                const y = ui.position.top;
                const height = ui.size.height;
                const width = ui.size.width;

                const oldX = self.model.get('left');
                const oldY = self.model.get('top');
                const oldHeight = self.model.get('height');
                const oldWidth = self.model.get('width');

                undoService.add({
                    undo:() => {
                        self.model.set({left: oldX, top: oldY, width: oldWidth, height: oldHeight},constants.MODEL_SILENT);
                        // Redraw selection rectangle
                        focusController.selectionRectangle( self.model.get('id') );
                        self.render();
                    },
                    redo: () => {
                        self.model.set({left: x, top: y, width: width, height: height},constants.MODEL_SILENT);
                        // Redraw selection rectangle
                        focusController.selectionRectangle( self.model.get('id') );
                        self.render();
                    }
                },  textConstants.UNDO_RESIZE);

                self.model.set({left: x, top: y, width: width, height: height},constants.MODEL_SILENT);

                // Redraw selection rectangle
                focusController.selectionRectangle( self.model.get('id') );
                self.render();
                focusController.switchTab(constants.SETTINGS_TAB);
            },
            minWidth: minWidth,
            minHeight: minHeight,
            containment: $parent
        });

        // PF-2665: Disable resize method by default
        // $('#' + this.model.get('id')).resizable('disable');
    }
}


export default BaseControlView;